







































































import { Component, Emit, Watch, Vue } from 'vue-property-decorator'
import { Factories } from '@finx/web-repository'
import DadosCadastraisStore from '@finx/web-repository/src/stores/DadosCobranca'
import PagamentoStore from '@finx/web-repository/src/stores/Pagamento'
import ApiPlans from '@finx/web-repository/src/apis/Plans/Plans'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'

const component: Object = {
  store: {
    DadosCadastraisStore,
    PagamentoStore,
  },
}

@Component(component)

export default class ComponentFormDadosCadastrais extends Vue {
  stores: any = {
    dadosCobranca: (this.$store as any).DadosCadastraisStore,
    pagamento: (this.$store as any).PagamentoStore,
  }

  Messages: any = Factories.Messages
  Validator: any = Factories.Validator
  formIsValid: Boolean = true
  tipoPessoa: String = ''

  get dadosCobranca() {
    return this.stores.dadosCobranca.getters.DADOS_COBRANCA
  }

  @Watch('dadosCobranca')
  watchDadosCobranca() {
    (this.$refs as any).formDadosCadastrais.resetValidation()
  }

  get loading() {
    return this.stores.pagamento.getters.LOADING
  }

  mounted() {
    this.getDadosCobranca()
  }

  changeTipoPessoa() {
    (this.$refs as any).formDadosCadastrais.resetValidation()
    this.dadosCobranca.pessoa.cpfCnpj = ''
  }

  async getDadosCobranca() {
    const request = await ApiLegacy.DadosCobranca.getDadosCobranca()
    const dc = this.dadosCobranca
    dc.pessoa = request.data.pessoa
    this.stores.dadosCobranca.commit('DADOS_COBRANCA', dc)
    this.setTipoPessoa()
  }

  @Emit('submit')
  submit() {
    this.stores.dadosCobranca.commit('DADOS_COBRANCA', this.dadosCobranca)
  }

  setTipoPessoa() {
    const isCpfCnpjEmpty = !this.dadosCobranca.pessoa.cpfCnpj
    let isCPF = true

    if (this.dadosCobranca.pessoa.cpfCnpj) {
      isCPF = this.dadosCobranca.pessoa.cpfCnpj.length === 11
    }

    if (isCpfCnpjEmpty) {
      this.tipoPessoa = 'PF'
    } else if (isCPF) {
      this.tipoPessoa = 'PF'
    } else {
      this.tipoPessoa = 'PJ'
    }
  }

  validate() {
    const form = (this.$refs as any).formDadosCadastrais

    if (form.validate()) {
      this.stores.pagamento.commit('LOADING', true)
      this.submit()
    }
  }
}
